/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Ground_Item_PortalInputs */

const en_auth_ground_item_portal = /** @type {(inputs: Auth_Ground_Item_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client portal`)
};

/** @type {(inputs: Auth_Ground_Item_PortalInputs) => LocalizedString} */
const ar_auth_ground_item_portal = en_auth_ground_item_portal;

/** @type {(inputs: Auth_Ground_Item_PortalInputs) => LocalizedString} */
const he_auth_ground_item_portal = en_auth_ground_item_portal;

/** @type {(inputs: Auth_Ground_Item_PortalInputs) => LocalizedString} */
const ur_auth_ground_item_portal = en_auth_ground_item_portal;

/** @type {(inputs: Auth_Ground_Item_PortalInputs) => LocalizedString} */
const es_auth_ground_item_portal = en_auth_ground_item_portal;

/** @type {(inputs: Auth_Ground_Item_PortalInputs) => LocalizedString} */
const fr_auth_ground_item_portal = en_auth_ground_item_portal;

/** @type {(inputs: Auth_Ground_Item_PortalInputs) => LocalizedString} */
const de_auth_ground_item_portal = en_auth_ground_item_portal;

/** @type {(inputs: Auth_Ground_Item_PortalInputs) => LocalizedString} */
const pt_auth_ground_item_portal = en_auth_ground_item_portal;

/** @type {(inputs: Auth_Ground_Item_PortalInputs) => LocalizedString} */
const hi_auth_ground_item_portal = en_auth_ground_item_portal;

/** @type {(inputs: Auth_Ground_Item_PortalInputs) => LocalizedString} */
const bn_auth_ground_item_portal = en_auth_ground_item_portal;

/**
* | output |
* | --- |
* | "Client portal" |
*
* @param {Auth_Ground_Item_PortalInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const auth_ground_item_portal = /** @type {((inputs?: Auth_Ground_Item_PortalInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Ground_Item_PortalInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_auth_ground_item_portal(inputs)
	if (locale === "he") return he_auth_ground_item_portal(inputs)
	if (locale === "ur") return ur_auth_ground_item_portal(inputs)
	if (locale === "es") return es_auth_ground_item_portal(inputs)
	if (locale === "fr") return fr_auth_ground_item_portal(inputs)
	if (locale === "de") return de_auth_ground_item_portal(inputs)
	if (locale === "pt") return pt_auth_ground_item_portal(inputs)
	if (locale === "hi") return hi_auth_ground_item_portal(inputs)
	if (locale === "bn") return bn_auth_ground_item_portal(inputs)
	return /** @type {LocalizedString} */ ("Client portal")
});